import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  keyframes,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// Icon
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import axios from "axios";
import { OrderContext } from "../contexts/OrderContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function UniversalDataTable(props) {
  const navigate = useNavigate();

  const { storeData } = useContext(OrderContext);
  const { storeInfo = [] } = storeData;
  const [openDeleteDialogBox, setOpenDeleteDialogBox] = useState(false);
  const [designToDelete, setDesignToDelete] = useState(null);

  // Loading animation
  const dotsAnimation = keyframes`
    0% { content: "."; }
    20% { content: ".."; }
    40% { content: "..."; }
    60% { content: "...."; }
    80% { content: "...."; }
    100% { content: "."; }
  `;

  // Loading screen until store info is there
  if (!storeInfo || storeInfo.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="60vh"
      >
        <Typography variant="h6" color="textSecondary">
          Loading store information
          <Box
            component="span"
            sx={{
              display: "inline-block",
              width: "1.5em",
              textAlign: "left",
              "::after": {
                content: '""',
                display: "inline-block",
                animation: `${dotsAnimation} 1s steps(3, end) infinite`,
              },
            }}
          />
        </Typography>
      </Box>
    );
  }

  // Storing the url prefix for images blob url
  const { url_prefix } = storeInfo[0];
  const storeURL = url_prefix;

  // Edit design handler
  const handleEditDesign = async (currentCatalogueData) => {
    navigate("/editcatalogue", {
      state: currentCatalogueData,
    });
  };

  // Open dialog box handler
  const handleOpenDeleteDialogBox = (design) => {
    setOpenDeleteDialogBox(true); // open dialog
    setDesignToDelete(design); // store selected design
  };

  // Close dialog box handler
  const handleCloseDeleteDialogBox = () => {
    setOpenDeleteDialogBox(false);
    setDesignToDelete(null);
  };

  // Delete design handler
  const handleConfirmDeleteDesign = async (tagNo) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/cataloguedelete/${tagNo}`
      );

      setOpenDeleteDialogBox(false);
      setDesignToDelete(null);

      if (
        props.onDesignDeleted &&
        typeof props.onDesignDeleted === "function"
      ) {
        props.onDesignDeleted(tagNo);
      }
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  if (props.tableFor === "Design Catalogue") {
    return (
      <TableContainer
        component={Paper}
        sx={{
          mb: 15,
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {/* Design catalogue table */}
        <Table>
          {/* Table Head */}
          <TableHead sx={{ backgroundColor: "#0D7377" }}>
            <TableRow>
              {/* Action buttons */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              ></TableCell>

              {/* Images */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Design Images</Typography>
              </TableCell>

              {/* Design Number */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Design Number</Typography>
              </TableCell>

              {/* Design Alias */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Design Alias</Typography>
              </TableCell>

              {/* Item */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Item</Typography>
              </TableCell>

              {/* Design */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Design</Typography>
              </TableCell>

              {/* Size */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Size</Typography>
              </TableCell>

              {/* Collection */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Collection</Typography>
              </TableCell>

              {/* Gross Weight */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Gross Weight</Typography>
              </TableCell>

              {/* Net Weight */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Net Weight</Typography>
              </TableCell>

              {/* No of Days */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>No of Days</Typography>
              </TableCell>

              {/* Tolerance/WT From */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Tolerance/WT From</Typography>
              </TableCell>

              {/* Tolerance/WT To */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Tolerance/WT To</Typography>
              </TableCell>

              {/* Design Date */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Design Date</Typography>
              </TableCell>

              {/* Karigar */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Karigar</Typography>
              </TableCell>

              {/* Status */}
              <TableCell
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                }}
              >
                <Typography>Status</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody sx={{ backgroundColor: "#E9F4F4" }}>
            {props.paginatedDesignsArray.map((design) => {
              return (
                // Table body data
                <TableRow key={design.design?.tagno}>
                  {/* Action Buttons */}
                  <TableCell>
                    <FormControl size="small" variant="outlined">
                      <Select displayEmpty renderValue={() => null}>
                        {/* Edit button */}
                        <MenuItem
                          value="edit"
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            gap: "0.4rem",
                          }}
                          onClick={() => handleEditDesign(design)}
                        >
                          <EditRoundedIcon sx={{ height: 20, width: 20 }} />
                          <Typography sx={{ fontSize: 16 }}>Edit</Typography>
                        </MenuItem>

                        {/* Delete button */}
                        <MenuItem
                          value="delete"
                          onClick={() => handleOpenDeleteDialogBox(design)}
                        >
                          <DeleteForeverRoundedIcon
                            sx={{ height: 20, width: 20 }}
                          />
                          <Typography sx={{ fontSize: 16 }}>Delete</Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>

                  {/* Images */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      padding: "0.8rem",
                    }}
                  >
                    <div key={design.tagno_alpha}>
                      {/* <picture>
                          <source
                            srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.jpg`}
                            type="image/jpeg"
                          />
                          <source
                            srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.jpeg`}
                            type="image/jpeg"
                          />
                          <source
                            srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.png`}
                            type="image/png"
                          />
                          <source
                            srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.webp`}
                            type="image/webp"
                          />
                          <source
                            srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.gif`}
                            type="image/gif"
                          />
                          <img
                            src={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno}.jpg`}
                            alt={`${design.tagno_alpha} preview`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: 2,
                            }}
                          />
                        </picture> */}
                      <picture>
                        <source
                          srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.jpg`}
                          type="image/jpeg"
                        />
                        <source
                          srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.jpeg`}
                          type="image/jpeg"
                        />
                        <source
                          srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.png`}
                          type="image/png"
                        />
                        <source
                          srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.webp`}
                          type="image/webp"
                        />
                        <source
                          srcSet={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.gif`}
                          type="image/gif"
                        />
                        <img
                          src={`https://kumuduorderapp.blob.core.windows.net/${storeURL}/${design.tagno_alpha}.jpg`}
                          alt={`${design.tagno_alpha} preview`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 2,
                          }}
                        />
                      </picture>
                    </div>
                  </TableCell>

                  {/* Design no */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.tagno_alpha}
                  </TableCell>

                  {/* Design alias */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.certificateno}
                  </TableCell>

                  {/* Item type */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {props.localStorageData?.itemtypes?.find(
                      (item) => item.id === design.itemtype
                    )?.name || "--"}
                  </TableCell>

                  {/* Design type */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {props.localStorageData?.designs?.find(
                      (designType) => designType.id === design.design
                    )?.name || "--"}
                  </TableCell>

                  {/* Size */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.s_size_len}
                  </TableCell>

                  {/* Collection */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.mfn_code}
                  </TableCell>

                  {/* Gross wt */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.gross + " gm"}
                  </TableCell>

                  {/* Net wt */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.netwt + " gm"}
                  </TableCell>

                  {/* No of days */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.pcs}
                  </TableCell>

                  {/* Tolerance from */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.tear_wt}
                  </TableCell>

                  {/* Tolerance to */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.pouch_tear_wt}
                  </TableCell>

                  {/* Design date */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {new Date(design.entrydate)
                      .toLocaleString("en-GB", {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                      })
                      .replace(",", "")
                      .replace(" at", ",")}
                  </TableCell>

                  {/* Karigar */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {props.localStorageData?.karigars?.find(
                      (karigar) => karigar.id === Number(design.supplier)
                    )?.name || "--"}
                  </TableCell>

                  {/* Status */}
                  <TableCell
                    sx={{
                      color: "black",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {design.status === "A" ? "Active" : "Inactive"}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        {/* Current page of pagination */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={2}
          mt={2}
          mb={2}
        >
          {Array.from(
            {
              length: Math.ceil(props.totalDesignsCount / props.designsPerPage),
            },
            (_, index) => (
              <Button
                key={index}
                variant={
                  props.currentPage === index + 1 ? "contained" : "outlined"
                }
                size="small"
                onClick={() => props.setCurrentPage(index + 1)}
                sx={{
                  backgroundColor:
                    props.currentPage === index + 1 ? "#0D7377" : "white",
                  color: props.currentPage === index + 1 ? "white" : "#0D7377",
                  borderColor: "#0D7377",
                  minWidth: "32px",
                }}
              >
                {index + 1}
              </Button>
            )
          )}
        </Box>

        {/* Confirm delete dialogue box */}
        <Dialog open={openDeleteDialogBox} onClose={handleCloseDeleteDialogBox}>
          <DialogTitle>
            Confirm delete design - {designToDelete?.tagno_alpha}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to perform this action?
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              flexDirection: "column",
            }}
          >
            <Button
              onClick={handleCloseDeleteDialogBox}
              sx={{ color: "green" }}
            >
              No, keep design
            </Button>
            <Button
              onClick={() => handleConfirmDeleteDesign(designToDelete?.tagno)}
              sx={{ color: "red" }}
            >
              Yes, delete design
            </Button>
          </DialogActions>
        </Dialog>
      </TableContainer>
    );
  }
}

export default UniversalDataTable;
